var exports = {
  "kL": "SwitchGroup.module__container___dGRTbi",
  "AS": "SwitchGroup.module__item___dGRTbi",
  "Ly": "SwitchGroup.module__itemContent___dGRTbi",
  "IR": "SwitchGroup.module__itemLabel___dGRTbi",
  "a": "SwitchGroup.module__itemLabelInteractive___dGRTbi",
  "r9": "SwitchGroup.module__disabled___dGRTbi",
  "QK": "SwitchGroup.module__labelText___dGRTbi",
  "LE": "SwitchGroup.module__shortcut___dGRTbi",
  "ce": "SwitchGroup.module__extraContent___dGRTbi",
};

module.exports = exports;
